import * as React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import styled from 'styled-components';
import { Modal } from 'antd';
import { Button } from 'components';

const SIGNATURE_RESOLUTION = { width: 400, height: 200 } as const;

interface CovidSigningProps {
  setSignature: React.Dispatch<React.SetStateAction<string>>;
  signature: string;
}

const CovidSigning: React.FC<CovidSigningProps> = ({
  setSignature,
  signature,
}) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const containerRef = React.useRef(null);
  let canvasRef: SignatureCanvas;
  const clearCanvas = () => canvasRef.clear();
  const cancel = () => {
    clearCanvas();
    setModalVisible(false);
  };
  const save = () => {
    if (canvasRef.isEmpty()) return;
    setSignature(canvasRef.getTrimmedCanvas().toDataURL('image/png'));
    setModalVisible(false);
  };

  return (
    <div>
      {signature ? (
        <img
          onClick={() => setModalVisible(true)}
          src={signature}
          alt="signature"
          style={{ width: '50%' }}
        />
      ) : (
        <Button type="primary" onClick={() => setModalVisible(true)}>
          Click to Sign
        </Button>
      )}
      <Modal
        data-cy="modal-popup"
        centered
        okText="Save"
        open={modalVisible}
        closable={false}
        onCancel={() => setModalVisible(false)}
        footer={null}
        bodyStyle={{ padding: '24px 0px' }}
        zIndex={4001} // Needs to be bigger than TourListingModal to avoid overlap
      >
        <FlexDiv>
          <h3>Draw your signature below: </h3>
          <HoverPointer onClick={clearCanvas}>clear</HoverPointer>
        </FlexDiv>

        <CanvasContainerDiv ref={containerRef}>
          <SignatureCanvas
            canvasProps={{
              width: SIGNATURE_RESOLUTION.width,
              height: SIGNATURE_RESOLUTION.height,
              style: {
                maxWidth: '100%',
                maxHeight: '100%',
                backgroundColor: 'white',
              },
            }}
            ref={ref => {
              canvasRef = ref;
            }}
          />
        </CanvasContainerDiv>

        <FlexDiv>
          <HoverPointer onClick={cancel}>Cancel</HoverPointer>
          <HoverPointer onClick={save}>
            <b>Save</b>
          </HoverPointer>
        </FlexDiv>
      </Modal>
    </div>
  );
};

const HoverPointer = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
const CanvasContainerDiv = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
`;

const FlexDiv = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export default CovidSigning;
